<template>
    <LayoutHelp
        :title="title"
        :description="description">
        <template v-slot:searchbox>
            <SearchBox />
        </template>
        <template v-slot:content>
            <router-link :to="localeRoute('help')"
                class="button button--wider-border  button--float-left button--small-text transparent--button button--l button--icon-left button--uppercase mm-section__faq-topic-button">
                <i class="button__icon icon-arrow-left"></i>
                {{$t('helpPage.backToList')}}
            </router-link>

            <LinkList
                v-if="data"
                :headingText="heading"
                :links="data"
                :fullWidth="true"
                :showMoreButton="false"
            />
        </template>
    </LayoutHelp>
</template>

<script>
import webCMS from '@/services/WebCMS';
import SearchBox from '@/components/help/search';
import LayoutHelp from '@/components/layouts/Help';
import LinkList from '@/components/help/linkList';

export default {
    components: {
        SearchBox,
        LayoutHelp,
        LinkList
    },
    created: function() {
        this.loadData();
    },
    data() {
        return {
            data: null
        };
    },
    props: {
        id: {
            type: String,
            required: true
        },
        heading: {
            type: String,
            required: true
        },
        title: {
            type: String
        },
        description: {
            type: String
        }
    },
    methods: {
        loadData() {
            webCMS.getLinksByTag(this.axios, {tag: this.id, limit: 500})
                .then(res => {
                    this.data = res;
                });
        },
    }
}
</script>

